import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function Audience() {
  return <section className="py-20 bg-cream" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        {/* Who is this for / not for */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24" data-id="element-3">
          <FadeIn direction="right" data-id="element-4">
            <div className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border-t-8 border-sage" data-id="element-5">
              <h3 className="text-2xl font-bold text-olive mb-8 flex items-center" data-id="element-6">
                <span className="bg-light-sage text-sage p-2 rounded-lg mr-4" data-id="element-7">
                  <CheckCircle2Icon className="w-6 h-6" data-id="element-8" />
                </span>
                Esto ES para ti si:
              </h3>
              <ul className="space-y-5" data-id="element-9">
                {['Eres una mamá latina en USA que trabaja y siente que no le alcanza el tiempo.', "Sufres de 'parálisis por desorden' y no sabes por dónde empezar.", 'Amas recibir gente pero odias el estrés previo de la limpieza.', 'Eres emprendedora y necesitas un entorno ordenado para ser productiva.'].map((item, index) => <li key={index} className="flex items-start" data-id="element-10">
                    <CheckCircle2Icon className="w-5 h-5 text-sage shrink-0 mr-3 mt-1" data-id="element-11" />
                    <span className="text-olive/80" data-id="element-12">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={200} direction="left" data-id="element-13">
            <div className="bg-white/50 rounded-3xl p-8 md:p-10 border border-olive/10" data-id="element-14">
              <h3 className="text-2xl font-bold text-olive mb-8 flex items-center opacity-80" data-id="element-15">
                <span className="bg-olive/10 text-olive/60 p-2 rounded-lg mr-4" data-id="element-16">
                  <XCircleIcon className="w-6 h-6" data-id="element-17" />
                </span>
                Esto NO es para ti si:
              </h3>
              <ul className="space-y-5" data-id="element-18">
                {['Buscas una guía de limpieza profunda o desinfección química extrema.', 'Tienes personal de limpieza diario y no tocas una escoba.', 'Prefieres pasar el sábado entero limpiando en lugar de disfrutar tu tiempo libre.'].map((item, index) => <li key={index} className="flex items-start opacity-70" data-id="element-19">
                    <XCircleIcon className="w-5 h-5 text-olive/40 shrink-0 mr-3 mt-1" data-id="element-20" />
                    <span className="text-olive/70" data-id="element-21">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        {/* How it works */}
        <div className="max-w-4xl mx-auto" data-id="element-22">
          <FadeIn data-id="element-23">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-olive mb-16" data-id="element-24">
              ¿Cómo funciona? Es simple.
            </h2>
          </FadeIn>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-sage/30 before:to-transparent" data-id="element-25">
            {[{
            step: '1',
            title: 'Descarga y Localiza',
            desc: "Descarga la guía al instante y localiza tus 'Zonas de Pánico' en menos de 5 minutos."
          }, {
            step: '2',
            title: 'Aplica la Regla de 2 Minutos',
            desc: 'Aprende a detener el desorden en seco antes de que se acumule y se vuelva inmanejable.'
          }, {
            step: '3',
            title: 'Transforma en 15 Minutos',
            desc: 'Usa el Cronómetro de 15 Minutos para transformar tu sala y cocina sin sudar, justo antes de que lleguen las visitas.'
          }].map((item, index) => <FadeIn key={index} delay={index * 150} direction="up" data-id="element-26">
                <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-27">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-cream bg-sage text-white font-bold text-xl shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-md z-10" data-id="element-28">
                    {item.step}
                  </div>
                  <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-2xl bg-white shadow-soft border border-sage/10" data-id="element-29">
                    <h4 className="text-xl font-bold text-olive mb-2" data-id="element-30">
                      {item.title}
                    </h4>
                    <p className="text-olive/70" data-id="element-31">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}